import * as actionTypes from '../../constants/actionTypes';

const initialState = {};

export default function(state = initialState, action) {
  switch (action.type) {
    case actionTypes.CLEAR_DATA:
      return action.payload;
    case actionTypes.FETCH_CROP_STATS_SUCCESS:
    case actionTypes.FETCH_CROP_STATS_ERROR:
      return action.payload;
    default:
      return state;
  }
}
